import HSHighlightedFeatures from './hs-highlighted-features';

export default HSHighlightedFeatures;
